import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const Taxes = ({ contract }: { contract: Contract }) => {
  // Priority: product address > agentSellerInfo > fallback
  const propertyState =
    contract?.product?.address?.state ||
    contract?.agentSellerInfo?.propertyState ||
    'N/A';

  return (
    <View style={styles.section}>
      <Text style={styles.title}>Real Estate Taxes and Assessed Value</Text>
      <Text style={styles.list}>
        In {propertyState}, taxing authorities (school districts and
        municipalities) and property owners may appeal the assessed value of a
        property at the time of sale, or at any time thereafter. A successful
        appeal by a taxing authority may result in a higher assessed value for
        the property and an increase in property taxes. Also, periodic
        county-wide property reassessments may change the assessed value of the
        property and result in a change in property tax.
      </Text>
    </View>
  );
};

export default Taxes;
